module.exports = __webpack_public_path__ + "img/idcard_01.0be4242f.png";